import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";

type MapTooltipSlice = {
    mapTooltipIsVisible: boolean,
    mapTooltipIsLoading: boolean,
    tooltipInfoCopied: boolean,
    data: Record<string, any>,
    tooltipRoadName: string | null,
    tooltipPathName: string | null,
    tooltipKm: string | null,
}

function getInitialState() {
    const initialState: MapTooltipSlice = {
        mapTooltipIsVisible: false,
        mapTooltipIsLoading: false,
        data: {},
        tooltipRoadName: null,
        tooltipPathName: null,
        tooltipKm: null,
        tooltipInfoCopied: false,
    }
    return initialState
}


export const mapTooltipSlice = createSlice({
    name: 'mapTooltip',
    initialState: getInitialState(),
    reducers: {
        // состояние включенности подсказки (вкл./выкл. по кнопке)
        setMapTooltipIsLoading(state, action: PayloadAction<any>) {
            state.mapTooltipIsLoading = action.payload
        },
        // состояние видимости подсказки (если нет объектов, то не видим)
        setMapTooltipIsVisible(state, action: PayloadAction<any>) {
            state.mapTooltipIsVisible = action.payload
        },
        // универсальные динамические данные подсказки
        setMapTooltipData(state, action: PayloadAction<Record<string, any>>) {
            state.data = { ...state.data, ...action.payload };
        },
        resetMapTooltipData(state) {
            state.data = {};
        },
        // общие поля
        setMapTooltipRoadName(state, action: PayloadAction<string>) {
            state.tooltipRoadName = action.payload
        },
        setMapTooltipPathName(state, action: PayloadAction<string>) {
            state.tooltipPathName = action.payload
        },
        setMapTooltipKm(state, action: PayloadAction<string>) {
            state.tooltipKm = action.payload
        },
        // координаты участка теперь можно хранить в data, если потребуется
        setMapTooltipInfoCopied(state, action: PayloadAction<boolean>) {
            state.tooltipInfoCopied = action.payload
        },
        // маркер нормативности тоже можно хранить в data
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setMapTooltipInfoCopied,
    setMapTooltipIsLoading,
    setMapTooltipKm,
    setMapTooltipPathName,
    setMapTooltipRoadName,
    setMapTooltipIsVisible,
    setMapTooltipData,
    resetMapTooltipData,
} = mapTooltipSlice.actions
export const mapTooltipReducer = mapTooltipSlice.reducer;
